import { takeLatest, put } from "redux-saga/effects";

import finalityRepository, { GetFinalityLogsResponse } from "../../../domain/repositories/FinalityRepository";

import {
  TRIGGER_GET_FINALITY_LOGS,
  TriggerGetFinalityLogs,

  RESET_GET_FINALITY_LOGS
} from "./types";

import {
  getFinalityLogsPending,
  getFinalityLogsSuccess,
  getFinalityLogsError
} from "./actions";
import { createCancellableSaga } from "../../../../../store/CancellableSaga";


function* handleTriggerGetFinalityLogs(action: TriggerGetFinalityLogs) {
  const { payload } = action;
  const { request } = payload;

  yield put(getFinalityLogsPending());

  let response: GetFinalityLogsResponse;

  try {
    response = yield finalityRepository.getFinalityLogs(request);
  } catch (err) {
    yield put(getFinalityLogsError());
    return;
  }

  yield put(getFinalityLogsSuccess(response));
}


export function* watchGetFinalityLogsSaga() {
  yield takeLatest(TRIGGER_GET_FINALITY_LOGS, handleTriggerGetFinalityLogs);
}


export const getFinalityLogsSaga = createCancellableSaga(
  watchGetFinalityLogsSaga, RESET_GET_FINALITY_LOGS
);